import React from "react";
import styled from "styled-components";

import { Icons } from "src/library/components/Icon/types";
import FileItem from "src/core/shared/components/files/FileItem";

export type FileData = {
  s3FileKey: string;
  name: string;
};

interface ListFilesProps {
  onFileClick: (file: FileData) => void;
  icon?: Icons;
  files?: FileData[];
}

/**
 * loops through given files to create <ul> of file items
 */
const ListFiles: React.ReactFCWithChildren<ListFilesProps> = ({
  onFileClick,
  icon = Icons.CLOSE,
  files = []
}) => {
  return (
    <UlWrapper className="list-files-ul">
      {files.length > 0 &&
        files.map(file => (
          <FileItem
            key={file.s3FileKey}
            onFileClick={onFileClick}
            file={file}
            icon={icon}
          />
        ))}
    </UlWrapper>
  );
};

const UlWrapper = styled.ul`
  margin-top: 35px;
`;

export default ListFiles;
